import { Accordion } from '@/components/Accordion';
import { LoyaltyCard } from '@/components/LoyaltyCard';
import { Spinner } from '@/components/Spinner';
import { useCustomerLoyalty } from '@/context/LoyaltyContext';
import { useFetchCustomerLoyalty } from '@/hooks/useFetchCustomerLoyalty';
import { useLoyaltyTierAccordionItems } from '@/hooks/useLoyaltyTierAccordionItems';
import { usePointsAccordionItems } from '@/hooks/usePointsAccordionItems';
import { E_AccordionType } from '@/types/Accordion';

import { NotFound } from './NotFound';

export const RegisteredCustomer = () => {
  const { customerLoyalty } = useCustomerLoyalty();

  const { loading, notFound } = useFetchCustomerLoyalty({ autoFetch: true });

  // TODO: create global loader
  if (loading) {
    return (
      <div className='flex h-full items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  if (notFound) {
    return <NotFound />;
  }

  if (!customerLoyalty) return null;

  const { basicInfo, programs } = customerLoyalty;
  if (!programs) return null;
  const { loyaltyTier, flexiblePoints, coupons } = programs;
  const loyaltyTierAccordionItems = loyaltyTier
    ? useLoyaltyTierAccordionItems(loyaltyTier, basicInfo)
    : [];

  const hasAnyPointsProgram = flexiblePoints || coupons;

  const loyaltyPointsAccordionItems = hasAnyPointsProgram
    ? usePointsAccordionItems(
        flexiblePoints ? { ...flexiblePoints, currency: basicInfo?.currency } : undefined,
        Boolean(flexiblePoints),
        coupons,
      )
    : [];

  return (
    <>
      <LoyaltyCard loading={loading} />

      <div className='mt-4 space-y-6'>
        {loyaltyTier && (
          <Accordion
            type={E_AccordionType.MULTIPLE}
            defaultValue={['tiers']}
            className='space-y-3'
            items={loyaltyTierAccordionItems}
          />
        )}

        {hasAnyPointsProgram && (
          <Accordion
            type={E_AccordionType.MULTIPLE}
            defaultValue={['points']}
            className='space-y-3'
            items={loyaltyPointsAccordionItems}
          />
        )}
      </div>
    </>
  );
};
